import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  nav: {
    home: { sk: "Domov", en: "Home" },
    gallery: { sk: "Galéria", en: "Gallery" },
    exhibition: { sk: "Výstava", en: "Exhibition" },
    about: { sk: "O mne", en: "About" },
    contact: { sk: "Kontakt", en: "Contact" },
  },
  hero: {
    overline: { sk: "Marián Hriňa — Polymat", en: "Marián Hriňa — Polymath" },
    title1: { sk: "Ok-no", en: "A window" },
    title2: { sk: "do mojej", en: "to my" },
    title3: { sk: "mysle", en: "mind" },
    sub: {
      sk: "Umenie pre ľudí, nie pre umelca. Maľba, ktorá otvára zmysly a srdce — hlboký cit a osobná premena.",
      en: "Art for people, not for the artist. Painting that opens the senses and the heart — deep feeling and personal transformation.",
    },
    cta1: { sk: "Pozrieť galériu", en: "View Gallery" },
    cta2: { sk: "Spojiť sa", en: "Get in Touch" },
  },
  gallery: {
    overline: { sk: "Diela", en: "Works" },
    title: { sk: "Galéria", en: "Gallery" },
    intro: {
      sk: "Obrazy a objekty vytvárajú dialóg medzi osobným príbehom, energiou okamihu a hľadaním ticha.",
      en: "Paintings and objects create a dialogue between a personal story, the energy of the moment, and the search for silence.",
    },
    all: { sk: "Všetko", en: "All" },
    cats: {
      vystava1: { sk: "Výstava ArtGate", en: "Exhibition ArtGate" },
      vystava2: { sk: "Výstava JE-DNA", en: "Exhibition One" },
      nic: { sk: "Nič", en: "Nothing" },
    },
    empty: { sk: "Čoskoro pribudnú nové diela.", en: "New works coming soon." },
    interested: { sk: "Mám záujem o toto dielo", en: "I'm interested in this work" },
  },
  exhibition: {
    overline: { sk: "Výstava", en: "Exhibition" },
    title: { sk: "Horizonty svetla a ticha", en: "Horizons of Light & Silence" },
    body: {
      sk: "Výstava predstavuje výber diel autora vzniknutých počas obdobia osobnej premeny. Obrazy a objekty vytvárajú dialóg medzi energiou, ekológiou a atómom – medzi silou, ktorá formuje svet, a tichom, ktoré dáva priestor vnímať.",
      en: "The exhibition presents a selection of the author's works created during a period of personal transformation. Paintings and objects form a dialogue between energy, ecology and the atom – between the force that shapes the world and the silence that gives space to perceive.",
    },
    note: { sk: "Výstava neobsahuje fotografie.", en: "The exhibition does not contain photographs." },
    location: { sk: "Miesto", en: "Location" },
    place: { sk: "ARTGATE – Martin", en: "ARTGATE – Martin" },
    dates: { sk: "Termín", en: "Dates" },
    pillars: {
      energia: {
        t: { sk: "Energia", en: "Energy" },
        d: { sk: "Sila, ktorá formuje a premieňa. Prúd, ktorý spája.", en: "The force that shapes and transforms. The current that connects." },
      },
      ekologia: {
        t: { sk: "Ekológia", en: "Ecology" },
        d: { sk: "Zodpovednosť voči Zemi. Dialóg človeka s prírodou.", en: "Responsibility toward the Earth. A dialogue between man and nature." },
      },
      atom: {
        t: { sk: "Atóm", en: "Atom" },
        d: { sk: "Jadro energie. Rovnováha sily a vedomia.", en: "The core of energy. A balance of force and consciousness." },
      },
    },
  },
  about: {
    overline: { sk: "O mne", en: "About me" },
    title: { sk: "Otvorený ľuďom", en: "Open to People" },
    p1: {
      sk: "Som Marián Hriňa — maliar, ktorý chce byť osobný a otvorený. Moja tvorba je hlbokým citom a premenou. Tieto diela vznikli počas obdobia osobnej premeny.",
      en: "I am Marián Hriňa — a painter who wants to be personal and open. My work is deep feeling and transformation. These works were created during a period of personal change.",
    },
    p2: {
      sk: "Umenie pre mňa nie je pre umelca — je pre ľudí. Je to okno do mojej mysle. Obrazy vytvárajú dialóg medzi osobným príbehom, energiou okamihu a hľadaním ticha. Formovali ma majstri svetla a gesta — J. M. W. Turner, Vincent van Gogh, Mark Rothko a Jackson Pollock.",
      en: "For me, art is not for the artist — it is for people. It is a window into my mind. The paintings create a dialogue between a personal story, the energy of the moment, and the search for silence. I was shaped by the masters of light and gesture — J. M. W. Turner, Vincent van Gogh, Mark Rothko, and Jackson Pollock.",
    },
    quote: {
      sk: "„Umenie je pre ľudí, nie pre umelca. Je to okno do mojej mysle.“",
      en: "\u201CArt is for people, not for the artist. It is a window into my mind.\u201D",
    },
    signature: { sk: "— Marián Hriňa", en: "— Marián Hriňa" },
    poem: {
      overline: { sk: "Báseň", en: "Poem" },
      note: {
        sk: "„Vrstvy je báseň, ktorú pre mňa napísala Monika Kalafut. Zachytila v slovách to, čo ja vyjadrujem farbou – hľadanie, stratu, svetlo, ktoré prichádza až potom. Nesie rovnaké vrstvy ako moje obrazy. Som rád, že môže byť súčasťou tejto stránky.“",
        en: "„Vrstvy je báseň, ktorú pre mňa napísala Monika Kalafut. Zachytila v slovách to, čo ja vyjadrujem farbou – hľadanie, stratu, svetlo, ktoré prichádza až potom. Nesie rovnaké vrstvy ako moje obrazy. Som rád, že môže byť súčasťou tejto stránky.“",
      },
    },
  },
  contact: {
    overline: { sk: "Kontakt", en: "Contact" },
    title: { sk: "Spojme sa", en: "Let's Connect" },
    intro: {
      sk: "Máte otázku, záujem o dielo alebo spoluprácu? Napíšte mi — rád sa s vami spojím.",
      en: "Have a question, an interest in a work, or a collaboration in mind? Write to me — I'd love to connect.",
    },
    name: { sk: "Vaše meno", en: "Your name" },
    email: { sk: "Váš email", en: "Your email" },
    message: { sk: "Vaša správa", en: "Your message" },
    send: { sk: "Odoslať správu", en: "Send message" },
    sending: { sk: "Odosielam…", en: "Sending…" },
    success: { sk: "Ďakujem! Vaša správa bola odoslaná.", en: "Thank you! Your message has been sent." },
    error: { sk: "Niečo sa pokazilo. Skúste znova.", en: "Something went wrong. Please try again." },
  },
  footer: {
    rights: { sk: "Všetky práva vyhradené.", en: "All rights reserved." },
    tagline: { sk: "Umenie pre ľudí.", en: "Art for people." },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("sk");
  const toggle = useCallback(() => setLang((l) => (l === "sk" ? "en" : "sk")), []);
  const t = useCallback(
    (path) => {
      const node = path.split(".").reduce((o, k) => (o ? o[k] : undefined), dict);
      if (node && (node.sk !== undefined || node.en !== undefined)) return node[lang] ?? node.sk;
      return path;
    },
    [lang]
  );
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
